import React from "react";
import { BaseComponent } from "shared/components";

const DEFAULT_CUTS = [
    { value: 'C-Collar', label: 'C-Collar', categories: ['Tops, Shirts & Blouses', 'Dresses & Jumpsuits', 'Jumpers & Knitwear'] },
    { value: 'V-Collar', label: 'V-Collar', categories: ['Tops, Shirts & Blouses', 'Dresses & Jumpsuits', 'Jumpers & Knitwear'] },
    { value: 'Turtle Neck', label: 'Turtle Neck', categories: ['Tops, Shirts & Blouses', 'Dresses & Jumpsuits', 'Jumpers & Knitwear'] },

    { value: 'Classic', label: 'Classic', categories: ['Tops, Shirts & Blouses', 'Dresses & Jumpsuits', 'Jumpers & Knitwear', 'Trousers & Shorts', 'Skirts'] },
    { value: 'Cropped', label: 'Cropped', categories: ['Tops, Shirts & Blouses', 'Jumpers & Knitwear'] },
    { value: 'Cardigan', label: 'Cardigan', categories: ['Jumpers & Knitwear'] },
    { value: 'Long', label: 'Long', categories: ['*'] },

    { value: 'Classic Length', label: 'Classic Length', categories: ['Dresses & Jumpsuits', 'Skirts', 'Trousers & Shorts'] },
    { value: 'High Waist', label: 'High Waist', categories: ['Dresses & Jumpsuits', 'Skirts', 'Trousers & Shorts'] },
    { value: 'Jumper', label: 'Jumper', categories: ['Jumpers & Knitwear'] },
    { value: 'Long Line', label: 'Long Line', categories: ['Jumpers & Knitwear'] },
    { value: 'Loose', label: 'Loose', categories: ['*'] },
    { value: 'Oversized', label: 'Oversized', categories: ['Tops, Shirts & Blouses', 'Dresses & Jumpsuits', 'Jumpers & Knitwear'] },
    { value: 'Short', label: 'Short', categories: ['Dresses & Jumpsuits', 'Skirts', 'Trousers & Shorts'] },
    { value: 'Tight', label: 'Tight', categories: ['*'] }
];

/**
 *
 * @param choices list of choices
 * @param choicesStream should be a promise
 */
function withCutSelectButtons(choices, choicesStream = undefined, noReset = false) {
    return class extends BaseComponent {
        constructor(props) {
            super(props);

            this.defaultValue = props.value ? props.value : "";
            this.label = props.label ? props.label : "";

            this.state = {
                value: this.defaultValue,
                values: choices,
                noReset: noReset
            };

            this.onChange = this.onChange.bind(this);
            this.resetState = this.resetState.bind(this);
        }

        async componentDidMount() {
            if (choicesStream) {
                await choicesStream((values) => {
                    this.setState({ values });
                });
            }

            const value = this.state.values.find((v) => v.value === this.props.value)?.value;
            await this.setState({ value });
        }

        async componentDidUpdate(prevProps) {
            const { values } = this.state;
            if (this.props.value !== prevProps.value) {
                // find value by value
                const value = values.find((v) => v.value === this.props.value)?.value;
                await this.setState({ value });
            }

            if (this.props.category !== prevProps.category) {
                const category = this.props.category;

                const values = DEFAULT_CUTS.filter((cut) => cut.categories.includes(category) || cut.categories.includes('*'));

                await this.setState({ values });
            }
        }

        onChange(choice) {
            const currentChoices = this.props.value;

            if (currentChoices.includes(choice)) {
                const itemIndex = currentChoices.findIndex((cc) => cc === choice);
                currentChoices.splice(itemIndex, 1);
            } else {
                currentChoices.push(choice);
            }

            if (this.props.onChange) {
                const name = this.props.name;
                this.props.onChange({
                    target: { name, value: currentChoices }
                });
            }
        }

        resetState() {
            if (!this.state.noReset) {
                this.setState({ value: "" });
            }
        }

        render() {
            const { values } = this.state;
            const { value, className } = this.props;

            return (
                <React.Fragment>
                    <label className="label">
                        {this.props.label} <small className="is-size-7">(Multiple)</small>
                    </label>
                    <div className="columns is-multiline is-centered">
                        {values.map((v) => (
                            < div className="column is-4" key={v.label} >
                                <button
                                    type="button"
                                    className={`button ${className} is-fullwidth ${value.includes(v.label) ? "is-link" : ""}`}
                                    data-tooltip={v.label}
                                    onClick={() => this.onChange(v.value)}>{v.label}
                                </button>
                            </div>
                        ))}
                    </div>

                </React.Fragment >
            );
        }
    }
}

const CutSelectButtons = withCutSelectButtons(DEFAULT_CUTS);
export default CutSelectButtons;
